import { render, staticRenderFns } from "./ThaiLotto.vue?vue&type=template&id=1aa016c8"
import script from "./ThaiLotto.vue?vue&type=script&lang=js"
export * from "./ThaiLotto.vue?vue&type=script&lang=js"
import style0 from "./ThaiLotto.vue?vue&type=style&index=0&id=1aa016c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports